// src/pages/UserSettings.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

const UserSettings = () => {
  const { user, setUser } = useAuth();
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: ""
  });
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        phone: user.phone || ""
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;

    try {
      const response = await axios.put(`/api/userUpdate/${user.id}`, formData);
      setUser((prev) => ({ ...prev, ...formData }));
      setStatus("success");
    } catch (err) {
      console.error("❌ Error updating user settings:", err);
      setStatus("error");
    }
  };

  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang);
  };

  return (
    <div className="container py-4">
      <h2>{t("userSettings")}</h2>

      {status === "success" && <div className="alert alert-success">{t("settingsUpdated")}</div>}
      {status === "error" && <div className="alert alert-danger">{t("errorOccurred")}</div>}

      <form onSubmit={handleSubmit} className="row g-3">
        <div className="col-md-6">
          <label className="form-label">{t("firstName")}</label>
          <input name="firstName" value={formData.firstName} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label className="form-label">{t("lastName")}</label>
          <input name="lastName" value={formData.lastName} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label className="form-label">Email</label>
          <input name="email" value={formData.email} onChange={handleChange} className="form-control" type="email" required />
        </div>

        <div className="col-md-6">
          <label className="form-label">{t("phone")}</label>
          <input name="phone" value={formData.phone} onChange={handleChange} className="form-control" />
        </div>

        <div className="col-md-4">
          <label className="form-label">{t("language")}</label>
          <select className="form-select" value={i18n.language} onChange={handleLanguageChange}>
            <option value="ua">UA</option>
            <option value="en">EN</option>
            <option value="pl">PL</option>
            <option value="ru">RU</option>
          </select>
        </div>

        <div className="col-12">
          <button className="btn btn-primary" type="submit">{t("saveChanges")}</button>
        </div>
      </form>
    </div>
  );
};

export default UserSettings;
